import { ContextStore } from 'bernie-plugin-mobx';
import { RouteComponentProps } from 'react-router-dom';
import * as React from 'react';

import { IncentivesCollectionCarousel } from '@shared-ui/retail-incentives-collection-carousel';

import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { SearchCriteriaModel } from 'stores/models';

import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

export interface ItemsVisibleForTracking {
  small?: number;
  medium?: number;
  large?: number;
  extraLarge?: number;
  defaultInViewport?: number;
}

export interface IncentivesCollectionCarouselWrapperProps extends Partial<RouteComponentProps> {
  inputs: {
    collectionId: string;
  };
  skipSsr?: boolean;
  pageContext: {
    propertySearch?: SearchCriteriaModel;
    context?: ContextStore;
  };
  itemsVisibleForTracking?: ItemsVisibleForTracking;
}

const defaultItemsVisibleForTracking: ItemsVisibleForTracking = {
  small: 3,
  medium: 4,
  large: 4,
  extraLarge: 4,
  defaultInViewport: 4,
};

export const IncentivesCollectionCarouselWrapper: React.FC<IncentivesCollectionCarouselWrapperProps> = props => {
  const { inputs, pageContext, itemsVisibleForTracking = defaultItemsVisibleForTracking, skipSsr = false } = props;
  const collectionId = inputs?.collectionId;
  const { context, propertySearch } = pageContext || {};

  if (!context || !propertySearch?.regionId || !collectionId) {
    return null;
  }

  const searchCriteria = adaptSearchCriteria(context, propertySearch, false);

  return (
    <SimpleLazyLoadWrapper placeholder={<></>}>
      <IncentivesCollectionCarousel
        inputs={{ collectionId: collectionId, pageContext: { propertySearch: searchCriteria } }}
        showPlaceholder={false}
        itemsVisibleForTracking={itemsVisibleForTracking}
        skipSsr={skipSsr}
      />
    </SimpleLazyLoadWrapper>
  );
};

IncentivesCollectionCarouselWrapper.displayName = 'IncentivesCollectionCarouselWrapper';
